import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PremiumGate } from '@/components/plans/plan-notice'
import { JumpNav, ToolPage } from '@/prakrit/components/grammar/tools/tool-page'
import { VachyaLab } from '@/prakrit/components/grammar/tools/vachya-lab'

const VachyaPage: FC = (): ReactNode => (
    <Layout>
        <Seo
            title='Passive and causative'
            description='वाच्य एवं प्रेरणार्थक: passive (कर्मवाच्य) and causative (प्रेरणार्थक) tables for any Prakrit root in अ, plus the conditional, each built step by step.'
        />
        <PremiumGate kind='grammar'>
            <ToolPage
                current='/grammar/vachya'
                eyebrow='वाच्य एवं प्रेरणार्थक · नि.८१–१०२'
                title={{ hi: 'वाच्य, प्रेरणार्थक और क्रियातिपत्ति', en: 'Passive, causative and conditional' }}
                intro={{
                    hi: '"पढ़ा जाता है", "पढ़वाता है" और "यदि पढ़ता तो" — एक ही धातु से वाक्य की दिशा बदलिए। धातु चुनिए, तालिका के किसी खाने पर टैप कीजिए और देखिए कि रूप कैसे बनता है और वाक्य में क्या बदलता है।',
                    en: '"Is read", "makes someone read" and "if he had read": change the direction of a sentence with one root. Choose a root, tap any cell and see how the form is built and what changes in the sentence.'
                }}
                kidsIntro={{
                    hi: 'एक ही धातु से नए अर्थ: "पढ़ा जाता है" और "पढ़वाता है"। धातु चुनो और देखो!',
                    en: 'One root, new meanings: "is read" and "makes someone read". Pick a root and see!'
                }}
                source='नि.८१–१०२'
                headerExtra={(
                    <JumpNav
                        links={[
                            { id: 'vachya-karmani', hi: 'कर्मवाच्य', en: 'Passive' },
                            { id: 'vachya-prerak', hi: 'प्रेरणार्थक', en: 'Causative' },
                            { id: 'vachya-kriyatipatti', hi: 'क्रियातिपत्ति', en: 'Conditional' }
                        ]}
                    />
                )}
            >
                <VachyaLab />
            </ToolPage>
        </PremiumGate>
    </Layout>
)

export default VachyaPage
